module.exports = __webpack_public_path__ + "static/img/tickets_fr.4162a75.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contest/tickets_fr.gif
// module id = 81
// module chunks = 0